import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ServicePageShell from '../../components/ServicePageShell';
import YoudGuimelDalethStatic from './YoudGuimelDalethStatic';

const YoudGuimelDaleth = () => (
  <ServicePageShell
    strapiApiId="service-youdguimdel-dalet"
    defaultTitle="Youd Guimel - Youd Daleth"
    StaticFallback={YoudGuimelDalethStatic}
  />
);

export default YoudGuimelDaleth;
